export enum LocalizationKeys {
  ItineraryReportCreated = 'itineraryReportCreated',
  ItineraryReportFailed = 'itineraryReportFailed'
}
